// Local rule-based extraction. This is NOT Sarvam AI and makes no network calls.
const CITIES = ["hyderabad", "హైదరాబాద్", "हैदराबाद", "bengaluru", "bangalore", "chennai", "mumbai", "visakhapatnam", "vizag", "vijayawada", "warangal", "tirupati", "pune", "jaipur", "delhi"];

export function extractPreview(text) {
  const lower = text.toLowerCase();
  const type = /wedding|marriage|పెళ్లి|शादी|ಮದುವೆ|திருமணம்|लग्न/i.test(text)
    ? "Wedding"
    : /corporate|conference|seminar|offsite|సమావేశం|सम्मेलन/i.test(text)
      ? "Corporate"
      : /birthday|anniversary|party|celebration/i.test(text) ? "Social" : null;
  const cityRaw = CITIES.find((c) => lower.includes(c));
  const city = cityRaw ? cityRaw.charAt(0).toUpperCase() + cityRaw.slice(1) : null;
  const m = text.match(/(\d{2,5})\s*(?:guests|people|pax|members|मेहमान|అతిథులు)/i);
  return { type, city, guests: m ? m[1] : null };
}
